import { render, staticRenderFns } from "./MyQuestions.vue?vue&type=template&id=0aeeafb4&"
import script from "./MyQuestions.vue?vue&type=script&lang=js&"
export * from "./MyQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports